import queryString from 'query-string'

export const parseQueryString = (
    query: string,
): {
    [key: string]: string
} => queryString.parse(query, { arrayFormat: 'index' })
